import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_187_bill_allocations: any[] = [
  {
    "componentType": "screenGroup",
    "fabAction": {
      "type": "add",
      "screenId": "188",
      "action": "navigate_modulev1/bill_allocations"
    },
    "title": "Bill wise allocations",
    "style": {
      "backgroundColor": "#F9FAFB"
    },
    "childComponents": [
      {
        "componentType": "group",
        "style": {
          "backgroundColor": "#ffffff",
          "direction": "column",
          "borderRadius": 12,
          "padding": 16
        },
        "childComponents": [
          {
            "componentType": "summeryList",
            "titleValue": "name",
            "Name": "receivables_summary",
            "BindValue": "grid_purchase",
            "Form": {
              "Name": "receivables_summary",
              "TableName": "",
              "Query": "SELECT cd.id AS id, cd.customername AS name, COALESCE(cd.address, '') AS address, COALESCE(SUM(ba.net_amount), 0) AS amount FROM customer_details cd INNER JOIN bill_allocations ba ON ba.customer_id = cd.id AND COALESCE(ba.soft_delete, 0) = 0 WHERE COALESCE(cd.soft_delete, 0) = 0 GROUP BY cd.id, cd.customername, cd.address",
              "View": "view_bill_allocation_list",
              "DisplayName": "receivables_summary",
              "Fields": [
                {
                  "IncludeLabel": true,
                  "Label": "id",
                  "BindValue": "id",
                  "Json_Attribute": "id",
                  "componentType": "textField",
                  "showInSummary": false,
                  "IsPrimary": true
                },
                {
                  "IncludeLabel": true,
                  "Label": "Customer name",
                  "BindValue": "suppliername",
                  "Json_Attribute": "name",
                  "componentType": "textField",
                  "showInSummary": true
                },
                {
                  "IncludeLabel": true,
                  "Label": "Customer address",
                  "BindValue": "address",
                  "Json_Attribute": "address",
                  "componentType": "textField",
                  "showInSummary": true
                },
                {
                  "IncludeLabel": true,
                  "Label": "Allocated Amount",
                  "BindValue": "amount",
                  "Json_Attribute": "amount",
                  "componentType": "textField",
                  "showInSummary": true
                }
              ]
            }
          }
        ]
      }
    ]
  }
];
